import React, { useEffect, useRef, useState } from 'react';
import subfacitiMmg from '../../../images/af-farm-img.jpg';
import Button from '../../../components/elements/button';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import Loader from '../../../components/loader';
import CreateSubFacilitiesModal from './createSubFacilities.modal';

interface Props {
    data: any;
    onCancel?: () => void;
    onCreatesub?:()=>void;
   
}

const SubFacilities: React.FC<Props> = ({ data, onCancel = ()=>{} ,onCreatesub = ()=>{}}) => {
    
    const [subFacilities, setSubFacilities] = useState<any[] | null>(null);
    const [subFacility, setSubFacility] = useState<any>(null);
    const [facilityID,setFacilityID] = useState<any>(null);
    const createSubFacilityModalRef: any = useRef();

    const getsubfacilitylist = (facilityID: any) => {
        const payload = { facilityID: facilityID };
        facilityApi.getSubFacilityList(payload, (resp: any) => {
            setSubFacilities(resp.subFacilityList || []);
        }, (error: any) => {
            console.log('error =>', error);
            setSubFacilities([]);
            // toast.error(error);
        });
    };
    const facilityApi: any = useFacilitiesApi();
    useEffect(() => {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~',data);
        if (data) {
            getsubfacilitylist(data?.facilityID)
            setFacilityID(data?.facilityID);
        }
        setSubFacilities(null);
    }, [data])
    const addsubfacility= ()=>{
        onCancel();
        onCreatesub();
      
    }
    return (
        <div className='pt-4'>
          <div className='flex justify-end pb-4'><Button type='button' onClick={addsubfacility}>Add SubFacility</Button></div>  
            {subFacilities == null && <Loader />}
            {subFacilities?.length == 0 && <p className='text-center'>Sub facility Not Found</p>}
            {subFacilities?.map((subfaci: any) => (
                <>
                    <div className='p-3 mb-3 border border-gray-200 rounded-md w-[99%]'>
                        <div className='flex justify-between text-[0.938rem] font-normal mb-2'>
                            <p className='cursor-pointer' onClick={()=>{
                               
                                setSubFacility(subfaci);
                                createSubFacilityModalRef.current.showModal();
                                onCancel();
                            }}>{subfaci.subFacilityTypeName}</p>
                            <p>{subfaci.no} - {subfaci.area}sqft</p>
                        </div>
                        <img className='rounded-md' src={subfaci.fullFilePath} alt="" />
                    </div>
                </>
            ))}
            <div className='flex justify-end gap-2'>
                <Button type="submit" onClick={onCancel}>Cancel</Button>
            </div>
            <CreateSubFacilitiesModal _ref={createSubFacilityModalRef} facilityId={facilityID} subFacility={subFacility} />
        </div>
    );
};

export default SubFacilities;